
const dataStep = [

    {
        id: 1,
        img: "/assets/cerv/home/icons/01-experimental.png",
        title: "Aprende haciendo",
        text: "Experimenta situaciones reales en simuladores virtuales diseñados para un aprendizaje efectivo y seguro."
    },
    {
        id: 2,
        img: "/assets/cerv/home/icons/02-disponibilidad.png",
        title: "Acceso virtual",
        text: "Utiliza simulaciones de alta precisión para representar equipos y espacios costosos o peligrosos."
    },
    {
        id: 3,
        img: "/assets/cerv/home/icons/03-estandarizacion.png",
        title: "Información precisa",
        text: "Aprovecha algoritmos avanzados para obtener evaluaciones consistentes y precisas."
    },
    {
        id: 4,
        img: "/assets/cerv/home/icons/04-100.png",
        title: "100% recomendado",
        text: "Diseñado y avalado por profesionales en e-learning y simuladores VR."
    },
    {
        id: 5,
        img: "/assets/cerv/home/icons/05-asimilacion.png",
        title: "Alta retención",
        text: "Logra una asimilación de conocimientos superior al 75%, gracias a técnicas inmersivas."
    }
];

export default dataStep;